// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/FluentSystemIcons-Resizable.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
  background-color: #ccc;
  background-image: linear-gradient(#eee, #ccc);
  border-radius: .2em;
  border: 1px solid #777;
  box-shadow: 0 0 1px 1px rgba(255, 255, 255, .8) inset, 0 1px 0 rgba(0,0,0,.3);
  color: #333;
  display: inline-block;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='#eeeeee', EndColorStr='#cccccc');
  font: bold 1em/2em Arial, Helvetica;
  margin: 0.5em;
  padding: 0 1.5em;
  text-decoration: none;
  text-shadow: 0 1px 0 rgba(255, 255, 255, .8);
  white-space: nowrap;
}

.button .button-glyph {
  height: 20px;
}

.button:hover:not([disabled]) {
  background-color: #ddd;
  background-image: linear-gradient(to top, #fafafa, #ddd);
  box-shadow: 0 0 10px #6e87b2, 0 0 15px #6e87b2, 0 0 60px #6e87b2;
  color: #074775;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='#fafafa', EndColorStr='#dddddd');
}

.button:active:not([disabled]) {
  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.3) inset;
  position: relative;
  top: 1px;
}

.button:focus:not([disabled]) {
  background: #fafafa;
  outline: 0;
}

.button:disabled {
  background-image: none;
  opacity: 0.5;
  text-decoration: none;
  text-shadow: none;
}

.button:before {
  background: #ccc;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0.15rem 0 0 0.15rem;
  box-shadow: 1px 0 0 rgba(0, 0 , 0, 0.5), 2px 0 0 rgba(255, 255, 255, 0.5);
  float: left;
  font-size: 1.5em;
  margin: 0 1em 0 -1em;
  padding: 0 0.2em;
  pointer-events: none;
  text-align: center;
  width: 1em;
}

@font-face {
  font-family: "FluentSystemIcons-Resizable";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}

/* Hexadecimal entities for the icons */

.add-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\E00C";
}

.add-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\E00D";
}

.apps-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\E070";
}

.apps-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\E071";
}

.cancel:before {
  content: "\\2717";
}

.delete-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\E650";
}

.delete-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\E651";
}

.edit:before {
  content: "\\270E";
}

.email-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EB55";
}

.email-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EB54";
}

.like:before {
  content: "\\2764";
}

.next-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EC3B";
}

.next-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EC3C";
}

.play-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EE16";
}

.play-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EE17";
}

.save-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EF1A";
}

.save-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EF1B";
}

.send-mail-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EF77";
}

.send-mail-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\EF78";
}

.sparkle-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\F070";
}

.sparkle-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\F071";
}

.star-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\F0D1";
}

.star-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\F0D2";
}

.toolbox-filled:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\F3F2";
}

.toolbox-regular:before {
  font-family: "FluentSystemIcons-Resizable";
  content: "\\F3F3";
}
`, "",{"version":3,"sources":["webpack://./src/css/button.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,6CAA6C;EAC7C,mBAAmB;EACnB,sBAAsB;EACtB,6EAA6E;EAC7E,WAAW;EACX,qBAAqB;EACrB,kGAAkG;EAClG,mCAAmC;EACnC,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;EACxD,gEAAgE;EAChE,cAAc;EACd,kGAAkG;AACpG;;AAEA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,yEAAyE;EACzE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,2DAAoE;AACtE;;AAEA,uCAAuC;;AAEvC;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB","sourcesContent":[".button {\n  background-color: #ccc;\n  background-image: linear-gradient(#eee, #ccc);\n  border-radius: .2em;\n  border: 1px solid #777;\n  box-shadow: 0 0 1px 1px rgba(255, 255, 255, .8) inset, 0 1px 0 rgba(0,0,0,.3);\n  color: #333;\n  display: inline-block;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='#eeeeee', EndColorStr='#cccccc');\n  font: bold 1em/2em Arial, Helvetica;\n  margin: 0.5em;\n  padding: 0 1.5em;\n  text-decoration: none;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, .8);\n  white-space: nowrap;\n}\n\n.button .button-glyph {\n  height: 20px;\n}\n\n.button:hover:not([disabled]) {\n  background-color: #ddd;\n  background-image: linear-gradient(to top, #fafafa, #ddd);\n  box-shadow: 0 0 10px #6e87b2, 0 0 15px #6e87b2, 0 0 60px #6e87b2;\n  color: #074775;\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorStr='#fafafa', EndColorStr='#dddddd');\n}\n\n.button:active:not([disabled]) {\n  box-shadow: 0 0 4px 2px rgba(0, 0, 0, 0.3) inset;\n  position: relative;\n  top: 1px;\n}\n\n.button:focus:not([disabled]) {\n  background: #fafafa;\n  outline: 0;\n}\n\n.button:disabled {\n  background-image: none;\n  opacity: 0.5;\n  text-decoration: none;\n  text-shadow: none;\n}\n\n.button:before {\n  background: #ccc;\n  background: rgba(0, 0, 0, 0.1);\n  border-radius: 0.15rem 0 0 0.15rem;\n  box-shadow: 1px 0 0 rgba(0, 0 , 0, 0.5), 2px 0 0 rgba(255, 255, 255, 0.5);\n  float: left;\n  font-size: 1.5em;\n  margin: 0 1em 0 -1em;\n  padding: 0 0.2em;\n  pointer-events: none;\n  text-align: center;\n  width: 1em;\n}\n\n@font-face {\n  font-family: \"FluentSystemIcons-Resizable\";\n  src: url(\"../fonts/FluentSystemIcons-Resizable.woff\") format('woff');\n}\n\n/* Hexadecimal entities for the icons */\n\n.add-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\E00C\";\n}\n\n.add-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\E00D\";\n}\n\n.apps-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\E070\";\n}\n\n.apps-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\E071\";\n}\n\n.cancel:before {\n  content: \"\\2717\";\n}\n\n.delete-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\E650\";\n}\n\n.delete-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\E651\";\n}\n\n.edit:before {\n  content: \"\\270E\";\n}\n\n.email-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EB55\";\n}\n\n.email-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EB54\";\n}\n\n.like:before {\n  content: \"\\2764\";\n}\n\n.next-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EC3B\";\n}\n\n.next-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EC3C\";\n}\n\n.play-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EE16\";\n}\n\n.play-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EE17\";\n}\n\n.save-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EF1A\";\n}\n\n.save-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EF1B\";\n}\n\n.send-mail-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EF77\";\n}\n\n.send-mail-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\EF78\";\n}\n\n.sparkle-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\F070\";\n}\n\n.sparkle-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\F071\";\n}\n\n.star-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\F0D1\";\n}\n\n.star-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\F0D2\";\n}\n\n.toolbox-filled:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\F3F2\";\n}\n\n.toolbox-regular:before {\n  font-family: \"FluentSystemIcons-Resizable\";\n  content: \"\\F3F3\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
